import routeName from '@/router/constant';

const typeName = '4';
const code = 'A4';
const backPage = routeName.CONTACT_INFO;

export const a4Header = [
    // {
    //     path: `${typeName}-contact-info`,
    //     name: routeName.A4_CONTACT_INFO,
    //     component: () => import('@/views/editTelAndMail/Index.vue'),
    //     meta: { auth: false, metaTitle: '確認聯絡資料', pageTitle: '請確認此保單資料', code },
    // },
];
export const a4Step = [
    {
        path: `${typeName}-set-account`,
        name: routeName.A4_SET_ACCONT,
        component: () => import('@/views/a3/landingPage/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            backPage,
            code,
            isNeedPolicyCard: true,
            unableBack: true,
        },
    },
    {
        path: `${typeName}-confirm`,
        name: routeName.A4_CONFIRM,
        component: () => import('@/views/a3/dataConfirm/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            backPage: routeName.A4_SET_ACCONT,
            code,
            isNeedPolicyCard: true,
            unableBack: true,
        },
    },
    {
        path: `${typeName}-OTP`,
        name: routeName.A4_OTP,
        component: () => import('@/views/otp/Index2.vue'),
        meta: {
            auth: true,
            metaTitle: '動態密碼驗證',
            leaveAlert: true,
            pageTitle: '請輸入動態密碼',
            code,
            backPage,
            unableBack: true,
        },

    },
];
